module.exports = __webpack_public_path__ + "images/icons/boat-storage/10x20--boat-space.svg";